var render = function render(){var _vm=this,_c=_vm._self._c;return _c('answers',{ref:"answers",attrs:{"code_question_group":"GQ13","danger_code":"MCAL33"}})
}
var staticRenderFns = []

export { render, staticRenderFns }